const containerStack = (theme) => ({
  gap: '3.375rem',
  alignSelf: 'stretch',
  padding: {
    xs: '4rem 2rem 2rem 2rem',
    ipad: '4rem 3rem 2rem 3rem',
    lg: '5rem 11.25rem 3.75rem 11.25rem',
  },
  borderRadius: '1.5rem 1.5rem 0 0',
  background: `linear-gradient(180deg, ${theme.palette.contrast.A700} 0%, #000 100%)`,
});

const titleTypography = {
  fontSize: { xs: '2.5rem', ipad: '3.375rem' },
  color: 'white',
};

const cardContainer = {
  display: 'flex',
  flexDirection: { xs: 'column-reverse', m: 'row' },
  padding: { xs: '2rem 2rem', ipad: '3.25rem 4rem' },
  justifyContent: 'space-between',
  alignItems: { xs: 'flex-start', ipad: 'center' },
  borderRadius: '2rem',
  gap: '2rem',
  maxWidth: '80rem',
  width: '100%',
};

const infoItemStack = {
  alignSelf: 'stretch',
  gap: '0.5rem',
};

const infoTitleTypography = (theme) => ({
  fontWeight: 600,
  color: theme.palette.neutral.A700,
});

const infoDescriptionTypography = (theme) => ({
  fontWeight: 500,
  color: theme.palette.neutral.A500,
});

export {
  containerStack,
  titleTypography,
  cardContainer,
  infoItemStack,
  infoTitleTypography,
  infoDescriptionTypography,
};
